import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";
//Invoices
import InvoiceReducer from "./invoices/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";
import CategoryReducer from "./category/reducer";
import ItemReducer from "./item/reducer";
import GST from "./gst/reducer";
import tagReducer from "./tag/reducer";
import HSNCodeReducer from "./hsn-code/reducer";
import useReducer from "./users/reducer";
import organisationReducer from "./organisations/reducer";
import teamReducer from "./team/reducer";
import usersTypeReducer from "./userstypes/reducer";
import departmentReducer from "./department/reducer";
import moduleReducer from "./modules/reducer";
import PermissionReducer from "./permissions/reducer";
import customerReducer from "./customer/reducer";
import BrandReducer from "./attributes/reducer";
import BrandMasterReducer from "./brand/reducer";
import ProcessorCorsReducer from "./processor_cors/reducer";
import ProcessorCacheReducer from "./processor_cache/reducer";
import ProcessorFrequencyReducer from "./peocessor_frequency/reducer";
import ProcessorSeriesReducer from "./processor_series/reducer";
import ProcessorSocketReducer from "./processor_socket/reducer";
import ProcessorThreadsReducer from "./processor_threads/reducer";
import ProcessorMotherBoardsReducer from "./motherbords_chips/reducer";
import MotherBoardsFromFactorReducer from "./motherboards_from_factor/reducer";
import ProcessorMotherBoardsMaxRam from "./motherboards_max_ram/reducer";
import ProcessorMotherBoardsSocket from "./motherboards_socket/reducer";
import ProcessorMemorySutaible from "./memory_sutaible/reducer";
import ProcessorRamCapacityReducer from "./ram_capacity/reducer";
import ProcessorRamChannelKitReducer from "./processor_ram_channel_kit/reducer";
import ProcessorRamSpeedReducer from "./ram_speed/reducer";
import ProcessorRamVoltageReducer from "./ram_voltage/reducer";
import ProcessGraphicsCardMemorySizeReducer from "./graphics_card_memory/reducer";
import ProcessorGraphicsCardSeriesReducer from "./graphics_card_series/reducer";
import ProcessorRamTypeReducer from "./ram_type/reducer";
import ProcessorSSDCapacityReducer from "./ssd_capacity/reducer";
import ProcessorSSDInterfaceReducer from "./ssd_interface/reducer";
import ProcessSSDMaxSequencialReducer from "./ssd_max_sequential_write/reducer";
import ConfigAtrributeReducer from "./attributes/config_attributes/reducer";

import TemplateReducer from "./template/reducer";
import QuotationReducer from "./Quotation/reducer";
import DashboardReducer from "./dashboard/reducer";

const rootReducer = combineReducers({
  users: useReducer,
  Organisations: organisationReducer,
  department: departmentReducer,
  teams: teamReducer,
  usersType: usersTypeReducer,
   modules: moduleReducer,
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  Category: CategoryReducer,
  ItemReducer: ItemReducer,
  HSNCode: HSNCodeReducer,
  Permission: PermissionReducer,
  GST: GST,
  customer: customerReducer,
  brand: BrandReducer,
  Brand: BrandMasterReducer,
  configAttribute: ConfigAtrributeReducer,
  TemplateReducer: TemplateReducer,
  QuotationReducer: QuotationReducer,
  DashboardReducer: DashboardReducer,
  processor_cors: ProcessorCorsReducer,
  tags: tagReducer,
  processor_cache: ProcessorCacheReducer,
  processor_frequnecy: ProcessorFrequencyReducer,
  processor_series: ProcessorSeriesReducer,
  processor_socket: ProcessorSocketReducer,
  processor_threads: ProcessorThreadsReducer,
  processor_motherboards_chips: ProcessorMotherBoardsReducer,
  processor_motherboards_from_factor: MotherBoardsFromFactorReducer,
  processor_motherboards_max_ram: ProcessorMotherBoardsMaxRam,
  processor_motherboards_socket: ProcessorMotherBoardsSocket,
  processor_memory_sutaible: ProcessorMemorySutaible,
  ram_capacity: ProcessorRamCapacityReducer,
  processor_ram_channel_kit: ProcessorRamChannelKitReducer,
  ram_speed: ProcessorRamSpeedReducer,
  ram_voltage: ProcessorRamVoltageReducer,
  graphics_card_memory_size: ProcessGraphicsCardMemorySizeReducer,
  graphics_card_series: ProcessorGraphicsCardSeriesReducer,
  ram_type: ProcessorRamTypeReducer,
  ssd_capacity: ProcessorSSDCapacityReducer,
  ssd_interface: ProcessorSSDInterfaceReducer,
  ssd_max_sequencial: ProcessSSDMaxSequencialReducer


});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
